var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3782 34.1426C20.958 35.5853 17.9764 35.5853 15.5563 34.1426L9.83022 30.7293C7.41011 29.2866 5.91927 26.6205 5.91927 23.7352L5.91927 16.9085C5.91927 14.0232 7.41011 11.3571 9.83022 9.91448L15.5562 6.50113C17.9764 5.05849 20.958 5.05849 23.3782 6.50113L29.1042 9.91447C31.5243 11.3571 33.0151 14.0232 33.0151 16.9085L33.0151 23.7352C33.0151 26.6205 31.5243 29.2866 29.1042 30.7293L23.3782 34.1426Z",
    fill: "#D3D6DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2968 28.1065L17.0229 31.5199C18.5354 32.4215 20.399 32.4215 21.9115 31.5199L27.6376 28.1065C29.1501 27.2049 30.0819 25.5385 30.0819 23.7352L30.0819 16.9085C30.0819 15.1052 29.1501 13.4389 27.6376 12.5372L21.9115 9.12391C20.399 8.22225 18.5354 8.22226 17.0229 9.12391L11.2968 12.5373C9.78426 13.4389 8.85248 15.1052 8.85248 16.9085L8.85248 23.7352C8.85248 25.5385 9.78426 27.2049 11.2968 28.1065ZM15.5563 34.1426C17.9764 35.5853 20.958 35.5853 23.3782 34.1426L29.1042 30.7293C31.5243 29.2866 33.0151 26.6205 33.0151 23.7352L33.0151 16.9085C33.0151 14.0232 31.5243 11.3571 29.1042 9.91447L23.3782 6.50113C20.958 5.05849 17.9764 5.05849 15.5562 6.50113L9.83022 9.91448C7.41011 11.3571 5.91927 14.0232 5.91927 16.9085L5.91927 23.7352C5.91927 26.6205 7.41011 29.2866 9.83022 30.7293L15.5563 34.1426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfinished);
export default __webpack_public_path__ + "static/media/unfinished.74e6f0358efe9fd3d922be72f1441941.svg";
export { ForwardRef as ReactComponent };